import React from 'react';
import Link from '../../../components/LocalizedLink';

const yritused = {
  "yritused.yld.pealkiri": "Üritused",
  "yritused.yld.blokk1": () => (
    <>
      <h2 className="title is-2">Ürituste korraldamine Varbla puhkekülas</h2>
      <p>
        Mitmekülgne hoonete kompleks, avar kadakane telkimisala ja liivarand
        võimaldavad pidada meeleolukaid- rahvarohkeid suursündmusi nagu
        suvepäevad, kokkutulekud, sünnipäevad, seminarid , pulmad.
      </p>
      <p>
        Koos erinevate koostööpartneritega aitame teil korraldada meeleolukaid
        ja meeldejäävaid üritusi koos maitsvate toitude ja karastavate
        jookidega.
      </p>
    </>
  ),
  "yritused.suvepaevad.pealkiri": "Suvepäevad",
  "yritused.suvepaevad.kaart.kirjeldus": () => (
    <p>Suvepäevad meie juures on meeleolukad ja seiklusrikkad.</p>
  ),
  "yritused.suvepaevad.blokk1": () => (
    <>
      <h2 className="title is-2">Suvepäevad Varbla puhkekülas</h2>
      <p>
        Mere ääres asuv Varbla Puhkeküla on suvepäevade korraldamiseks sobivaim
        paik. Aitame maha pidada meeldejäävad suvepäevad mere ääres kuni 500
        inimesele pakkudes kõiki vajalikke teenuseid kohapeal.
      </p>
      <p>Miks korraldada suvepäevad just Varbla Puhkekülas?</p>
      <ul>
        <li>Kaunis mere äärne asukoht ja liivarand otse puhkeküla külje all</li>
        <li>
          Mitmekülgne hoonetekompleks, majutusvõimalused kuni 142 inimesele,
          lisaks kadakane telkimisala
        </li>
        <li>
          Koostöös partneritega pakume hulgaliselt vaba aja tegevusi, sh
          surfamine ja surfikoolitused, hobused, seltskonnamängud jpm
        </li>
        <li>
          Kiidusõnu pälvinud road puhkeküla köögist, mis on valmistatud
          eestimaisest toorainest
        </li>
        <li>Suur parkimisala meie külalistele</li>
        <li>
          Muruplatsid, katusealused, istumiskohad-lauad ühistegevuste
          ettevõtmiseks
        </li>
        <li>
          Suvepäevade ajal avatud motellis baar ja telkimisalal müügikiosk
        </li>
        <li>2 eraldi sauna</li>
      </ul>
      <p>
        Lisaks suvepäevadele aitame korraldada teie firmapidusid ja -üritusi
        aastaringselt.
      </p>
      <p>
        Koostöös erinevate{" "}
        <Link to="/tegevused/koostoopartnerid">seiklusfirmadega</Link>{" "}
        korraldame Varblas aastaringselt erinevaid meeskonnamänge.
      </p>
    </>
  ),
  "yritused.suvepaevad.blokk2": () => (
    <>
      <h2 className="title is-2">Majutus</h2>
      <p>Majutusvõimalused on meil kuni 142-le inimesele:</p>
      <ul>
        <li>
          <Link to="/majutus/motell">motelli numbritoad</Link> (tubades dušš ja
          wc, merepoolsetel tubadel rõdu), kohti kuni 52-le
        </li>
        <li>
          <Link to="/majutus/ridaelamud">ridaelamuboksid</Link> (igas boksis
          puhketuba kööginurgaga), kohti kuni 32-le
        </li>
        <li>
          <Link to="/majutus/saunamajad">saunamajad</Link>, kohti kuni 12-le
        </li>
        <li>
          <Link to="/majutus/kampingud">kämpingud</Link>, kohti kuni 18-le
        </li>
        <li>
          <Link to="/majutus/palkmajad">palkmajad</Link> (Rännumehemaja,
          Päkapikumaja, Juuli&Aadu Saunamaja), kohti kuni 28-le
        </li>
      </ul>
      <p>
        Loe majutuse kohta lähemalt klikkides <Link to="/majutus">siia</Link>.
      </p>
    </>
  ),
  "yritused.suvepaevad.blokk3": () => (
    <>
      <h2 className="title is-2">Toitlustus</h2>
      <p>
        Pakume seltskonnale nii hommiku-, lõuna- kui õhtusööki, ning vajadusel
        ka hilisõhtust snäkki.
      </p>
      <p>Enamus meie toitudest valmivad kohapeal.</p>
      <p>
        Kasutame vastavalt hooajale, nii palju kui võimalik, Eestimaist
        toorainet.
      </p>
      <p>Toitlustamisel oleme saanud vaid kiidusõnu!</p>
      <p>
        Loe lähemalt meie toitlustusvõimaluste kohta klikkides{" "}
        <Link to="/toitlustus">siia</Link>.
      </p>
    </>
  ),
  "yritused.synnipaevad.pealkiri": "Sünnipäevad",
  "yritused.synnipaevad.kaart.kirjeldus": () => (
    <p>
      Meie juures peetud sünnipäevad ja juubelid on kordumatud ja meeldejäävad.
    </p>
  ),
  "yritused.synnipaevad.blokk1": () => (
    <>
      <h2 className="title is-2">Sünnipäevad Varbla puhkekülas</h2>
      <p>Iga inimese sünnipäevapidu peab olema kordumatu ja eriline.</p>
      <p>Anname endast parima, et sünnipäevapidu seda oleks.</p>
      <p>
        Peo saatjateks on maitsev ja eestimaine toit ning sõbralik majapere.
      </p>
      <p>
        Teeme kõigile huvilistele personaalse toitlustusmenüü ja aitame ka
        vajadusel bändi ja õhtujuhi otsingutel.
      </p>
    </>
  ),
  "yritused.synnipaevad.blokk2": () => <></>,
  "yritused.seminarid.pealkiri": "Seminarid",
  "yritused.seminarid.kaart.kirjeldus": () => (
    <p>Meri ja puhas loodus loob eelduse seminari korda minekuks.</p>
  ),
  "yritused.seminarid.blokk1": () => (
    <>
      <h2 className="title is-2">Seminaride pidamine Varbla puhkekülas</h2>
      <p>
        Seminarid ja koolitused Varbla Puhkekülas innustavad kõige värskematele
        ideedele ja mõtetele!
      </p>
      <p>
        Seminaride korraldamiseks pakume täisteenust: Siin peetud seminarid
        kauni merevaatega seminariruumis on iga korraldaja unistus.
      </p>
      <p>
        Meie seminariruum mahutab seminare kuni 40 osalejaga ning saunamaja ja
        puhkemaja on ideaalsed grupitööde või väiksemate nõupidamiste
        korraldamiseks.
      </p>
      <p>Mida pakume:</p>
      <ul>
        <li>toitlustust, kohvipause</li>
        <li>
          seminarijärgseid tegevusi: aktiivseid tegevusi ja saunaõhtut kuuma
          leili ja “hella” vihaga
        </li>
        <li>majutust hotellitasemega motellis või puhkemajades</li>
      </ul>
      <p>Seminariruum:</p>
      <ul>
        <li>Kuni 40 istekohta</li>
        <li>WiFi </li>
        <li>videoprojektor, ekraan</li>
        <li>pabertahvel</li>
        <li>väliterrass ja merevaade</li>
      </ul>
      <p>
        Väiksemaid seminare ja nõupidamisi on mugav korraldada meie saunamajas
        või puhkemajades.
      </p>
      <p>
        Suuremate nõupidamiste ja koolituste korral saab kasutada meie pubi
        ruumi, mis mahutab umbes 70 inimest ja suvel ka meie väliterrassi või
        vabaajategevuste platsi, mis mahutav üle 100 inimese.
      </p>
    </>
  ),
  "yritused.seminarid.blokk2": () => <></>,
  "yritused.pulmad.pealkiri": "Pulmad",
  "yritused.pulmad.kaart.kirjeldus": () => (
    <p>Pulmad mere kaldal - see on iga noorpaari unistus.</p>
  ),
  "yritused.pulmad.blokk1": () => (
    <>
      <h2 className="title is-2">Pulmapidu Varbla puhkekülas</h2>
      <p>
        Pulmad mere kaldal on iga pruutpaari unistus. Varbla Puhkekülas peetud
        pulmad muudavad selle olulise päeva Teie mõlema jaoks eriliseks.
        Päikeseloojang, piiritu avarus, mererand ning Sina ja Tema – mis võib
        veel romantilisem olla…{" "}
      </p>
      <p>
        Varbla Puhkeküla sobib nii väiksemate kui ka suuremate pulmade
        korraldamiseks. Puhkeküla peoruumi mahutame kuni 100 pulmakülalist.
        Suveperioodil pakume pulmade jaoks majutust kuni 142 inimesele ning
        talvel 84-le.{" "}
      </p>
      <p>Miks korraldada pulmad Varbla Puhkekülas? </p>
      <ul>
        <li>Romantiline ja privaatne asukoht otse mere kaldal </li>

        <li>Pika-ajaline kogemus pulmapidude korraldamisel</li>
        <li>
          Abivalmis ja heatahtlik personal, kes rõõmuga aitab korraldada kogu
          pulmapeo, meeleldi jagab oma kogemusi/soovitusi pulmaisade ja
          professionaalsete peokorraldajate kohta.
        </li>
        <li>
          Õdus peoruum, kuhu peolaua taha mahutame maksimum 100 külalist, jättes
          ruumi ka vahuveini-, tordi- ja külmlauale, muusikutele ja tantsijatele{" "}
        </li>
        <li>Kiidusõnu pälvinud puhkekeskuse köök ning maitsvad road </li>
        <li>
          Erinevad võimalused majutuseks: hotellitasemel toad, puhkemajad,
          kämpingud
        </li>
      </ul>
    </>
  ),
  "yritused.pulmad.blokk2": () => (
    <>
      <p>Loe lähemalt meie majutusvõimalustest siin:</p>
      <ul>
        <li>
          <Link to="/majutus/motell" activeClassName="is-active">
            motell
          </Link>{" "}
          (tubades dušš ja wc, merepoolsetel tubadel rõdu)
        </li>
        <li>
          <Link to="/majutus/ridaelamud" activeClassName="is-active">
            ridaelamuboksid
          </Link>{" "}
          (igas boksis 3 magamistuba ja puhketuba kööginurgaga ning dušš ja wc)
        </li>
        <li>
          <Link to="/majutus/puhkemajad" activeClassName="is-active">
            puhkemajad
          </Link>{" "}
          (privaatses kohas palkmajad, kõikides majades puhketuba kööginurgaga
          ning dušš ja wc){" "}
        </li>
        <li>
          <Link to="/majutus/saunamajad" activeClassName="is-active">
            saunamajad
          </Link>
        </li>
        <li>
          <Link to="/majutus/kampingud" activeClassName="is-active">
            kämpingud
          </Link>{" "}
          (kahekohalised)
        </li>
      </ul>
    </>
  ),
};

export default yritused;
